import React from "react";
import { UserTab } from "../../../userSlice";
import { UserProfile } from "../../../types/userAuthApiTypes";

// Import content components
import AccountDetails from "./Content/AccountDetails";
import AddressesTab from "./Content/AddressesTab/AddressesTab";
import DashboardHome from "./Content/DashboardHome";
import OrdersTab from "./Content/OrdersTab/OrdersTab";
import CouponsTab from "./Content/CouponsTab/CouponsTab"; // Ensure this is imported

interface ProfileContentProps {
  activeTab: UserTab;
  profile: UserProfile | undefined;
  isLoading: boolean;
  onTabChange: (tab: UserTab) => void;
}

const ProfileContent: React.FC<ProfileContentProps> = ({
  activeTab,
  profile,
  isLoading,
  onTabChange,
}) => {
  switch (activeTab) {
    case "orders":
      return <OrdersTab />;

    case "addresses":
      return <AddressesTab />;

    case "account":
      return <AccountDetails />;

    case "coupons":
      return <CouponsTab />;

    // 'dashboard' falls through to default, which is correct ONLY if nothing is between them
    case "dashboard":
    default:
      return (
        <DashboardHome
          profile={profile}
          isLoading={isLoading}
          onTabChange={onTabChange}
        />
      );
  }
};

export default ProfileContent;
